import { G } from '@mobily/ts-belt';
import { format } from 'date-fns';

import { tryToDateString, tryToLocalDate } from '@sh4res/bo-common/utils/date';

export function toUtcDateString(value: string | null): string | null {
  if (G.isNullable(value)) {
    return value;
  }
  return tryToDateString(value) ?? value;
}

/**
 * Formats a consultation date (dd/MM/yyyy) as the calendar day shown by the consultation period
 * inputs. The form can hold either a `YYYY-MM-DD` value or the backend's end-of-day UTC timestamp,
 * which formatted in local time would show the next day east of UTC.
 */
export function formatConsultationDate(value: unknown): string {
  const date = tryToLocalDate(value);
  return date ? format(date, 'dd/MM/yyyy') : '';
}
